<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  created() {
    const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    console.log('isIos', isIos, navigator.userAgent);
    // 仅在 iOS 且第一次访问时记录
    if (isIos) {
      const url = window.location.origin + window.location.pathname + window.location.search;
      sessionStorage.setItem('firstEntryUrl', url);
      console.log('[wechat] 记录首次访问 URL:', url);
    }
  },
};
</script>

<style lang="less">
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, /* structural elements 结构元素 */
dl, dt, dd, ul, ol, li, /* list elements 列表元素 */
pre, /* text formatting elements 文本格式元素 */
fieldset, lengend, button, input, textarea, /* form elements 表单元素 */
th, td {
  /* table elements 表格元素 */
  margin: 0;
  padding: 0;
}
#app {
  font-family: "普惠_2.0_medium", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.van-image__error {
  height: inherit !important;
}
</style>
